module.exports = "# This is a demo riddle, replace me!\n\nDearest Marjory,\n\nI come to you today with a *riddle* for you to solve! The solution is **two words, in this order**.\n\n1. The name of our first pet.\n2. Our word for affection.\n\nGood luck!"


//////////////////
// WEBPACK FOOTER
// ./src/examples/riddle.md
// module id = 101
// module chunks = 0